import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry';
import VenueAnalysis from './VenueAnalysis';
import {
    initialVenueAnalysisConfigurationState,
    VenueAnalysisConfigurationState,
} from './store/configuration/VenueAnalysisConfigurationState';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { venueAnalysisDescription } from './description/venueAnalysisDescription';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { VenueAnalysisByOrderIdsOrSymbolStreamRequest } from 'widgets/venueAnalysis/api/VenueAnalysisByOrderIdsOrSymbolStreamRequest';
import { venueAnalysisStreamConfig } from 'widgets/venueAnalysis/store/stream/stream-config';

export const venueAnalysisWidgetStrategy: WidgetStrategyWithConfig<VenueAnalysisConfigurationState> &
    WidgetStrategyWithStreamByRequestUid<VenueAnalysisByOrderIdsOrSymbolStreamRequest> =
    {
        title: 'Venue Analysis',
        supportedHosts: ['layout'],
        reactComponentType: VenueAnalysis,
        initialConfigState: initialVenueAnalysisConfigurationState,
        categories: [WidgetCategory.SINGLE_STOCK],
        description: venueAnalysisDescription,
        portfolioSelectionRequirements:
            PortfolioSelectionRequirements.SymbolFromAtLeastOneOrder,
        portfolioSelectionRequirementsWithoutOrdersStream:
            PortfolioSelectionRequirements.SingleSymbol,
        managedStreamConfig: venueAnalysisStreamConfig,
    };
